import Select from 'react-select';
import { selectStylesNoWrap } from '../bestek-filter/bestek-filter';
import { connect, useDispatch } from 'react-redux';
import { RootState } from '@/store';
import { WerkcatsState, werkcatActions } from '@/store/reducers/werkcats';
import { Werkcat } from '@/models/werkcat';
import { useEffect } from 'react';
import apiService from '@/api-service';

interface OwnProps {
    selected: Werkcat[];
    onChange: (value: Werkcat[]) => void;
}

interface Props extends OwnProps {
    werkcat_state: WerkcatsState;
}

function mapStateToProps(state: RootState, ownProps: OwnProps): Props {
    return Object.assign({
        werkcat_state: state.werkcats
    }, ownProps);
}

function HoofdcodeWerkCategorieFilter(props: Props): JSX.Element {
    const dispatch = useDispatch();

    useEffect(() => {
        if (!props.werkcat_state.loaded) {
            apiService.get<Werkcat[]>("/hoofdcode/werkcat")
                .then((res) => {
                    dispatch(werkcatActions.set_data(res.data.sort((a, b) => a.werk_categorie.localeCompare(b.werk_categorie))));
                }, console.error);
        }
    }, []);

    return (
        <>
            <label htmlFor="werkcat-select-box">Werkcategorie</label>
            <Select 
                styles={selectStylesNoWrap}
                inputId="werkcat-select-box" 
                options={props.werkcat_state.data} 
                getOptionLabel={(o) => `${o.werk_categorie} - ${o.omschrijving}`} 
                getOptionValue={(o) => o.id.toString()} 
                onChange={v => props.onChange([ ... v ])}
                value={props.selected}
                isLoading={!props.werkcat_state.loaded} 
                isMulti isClearable />
        </>
    );
}

export default connect(mapStateToProps)(HoofdcodeWerkCategorieFilter);